export type AudioRecorderControls = {
  start?: () => void;
  stop?: () => void;
  pause?: () => void;
  resume?: () => void;
  clear?: () => void;
};

export const getAudioRecorder = (): AudioRecorderControls =>
  (window as any).__audioRecorder ?? {};
